import {TOGGLE_TOUR_SECTION, ToggleTourSection, TourSectionAction} from "../actions";
import {TypeUtils} from "../../shared/utils/type-utils";

export interface ITourSectionState {
  toggled: boolean;
}

export const initialState: ITourSectionState = {
  toggled: false
};

export function reducer(state: ITourSectionState = initialState, action: TourSectionAction): ITourSectionState {
  switch (action.type) {

    case TOGGLE_TOUR_SECTION:
      let toggled: boolean = (<ToggleTourSection>action).payload;
      if (TypeUtils.isUndefined(toggled)) {
        toggled = !state.toggled;
      }

      return {
        ...state,
        toggled: toggled
      };

  }

  return state;
}
